import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Crisp } from "crisp-sdk-web";
import { getPerformance } from "firebase/performance";
// Internal dependencies
import './App.css';
import { Document, Documents } from './editor';
import { Root, ScrollToTop } from './root';
import { SignIn, RequiredAuth, EmailLinkVerification } from './sign-in';
import './i18n';
import { UserProvider, firebaseApp } from './auth';
import { CLIENT_ENDPOINTS, ROUTES } from './constants';
import { Settings } from './settings';
import { Infobase } from './infobase';
import { BrandVoices } from './brand-voices';
const perf = getPerformance(firebaseApp);
;
;
;
;
// Create ref theme
const refTheme = createTheme();
/** Create theme */
const theme = createTheme({
    // Set typography styles
    typography: {
        fontFamily: 'DM Sans',
        text28: {
            fontSize: '1.75rem',
            lineHeight: '2.25rem',
            fontWeight: '400',
        },
        text24: {
            fontSize: '1.5rem',
            lineHeight: '2rem',
            letterSpacing: '0.15px',
            fontWeight: '500',
        },
        text22: {
            fontSize: '1.375rem',
            lineHeight: '1.75rem',
            letterSpacing: '0.15px',
            fontWeight: '400',
        },
        text16: {
            fontSize: '1rem',
            lineHeight: '1.5rem',
            letterSpacing: '0.5px',
            fontWeight: '400',
        },
        text14: {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            textAlign: 'center',
            letterSpacing: '0.00625rem',
            fontWeight: '400',
        },
        text12: {
            fontSize: '0.75rem',
            lineHeight: '1rem',
            letterSpacing: '0.4px',
            fontWeight: '400',
        },
    },
    // Set palette colors
    palette: {
        primary: { main: '#006C49' },
        secondary: { main: '#D0E8D8' },
        thirdary: refTheme.palette.augmentColor({ color: { main: '#C0E9FB' } }),
        //forth: refTheme.palette.augmentColor({ color: { main: '#C0E9FB' } }),
        fifth: refTheme.palette.augmentColor({ color: { main: '#C3E8FE' } }),
        sixth: refTheme.palette.augmentColor({ color: { main: '#CEE9DD' } }),
        black: refTheme.palette.augmentColor({ color: { main: '#000000' } }),
        blackDark: refTheme.palette.augmentColor({ color: { main: '#191C1B' } }),
        blackLight: refTheme.palette.augmentColor({ color: { main: '#082018' } }),
        blackLighter: refTheme.palette.augmentColor({ color: { main: '#2E312F' } }),
        white: refTheme.palette.augmentColor({ color: { main: '#FFFFFF' } }),
        whiteDark: refTheme.palette.augmentColor({ color: { main: '#FAFAFA' } }),
        green: refTheme.palette.augmentColor({ color: { main: '#006B54' } }),
        greenDark: refTheme.palette.augmentColor({ color: { main: '#006C49' } }),
        greenDarker: refTheme.palette.augmentColor({ color: { main: '#707973' } }),
        greenLight: refTheme.palette.augmentColor({ color: { main: '#CEE9DD' } }),
        greenLighter: refTheme.palette.augmentColor({ color: { main: '#4B635A' } }),
        greenLightLighter: refTheme.palette.augmentColor({ color: { main: '#3F4945' } }),
        blueLight: refTheme.palette.augmentColor({ color: { main: '#C3E8FE' } }),
        blueLighter: refTheme.palette.augmentColor({ color: { main: '#61DBB7' } }),
        greyBlack: refTheme.palette.augmentColor({ color: { main: '#404943' } }),
        greyLight: refTheme.palette.augmentColor({ color: { main: '#BFC9C3' } }),
        pinkLight: refTheme.palette.augmentColor({ color: { main: '#FFDAD6' } }),
        success: { main: '#D0E8D8' },
    },
    // Set breakpoints
    breakpoints: {
        values: {
            xs: 0,
            ls: 450,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            xxl: 1700, // Add xxl
        },
    },
});
/** Global styles */
const /** Global styles */ globalStyles = {
    color: '#000000',
    fontFamily: 'DM Sans',
    fontWeight: '400',
    '.MuiPaper-root': {
        borderRadius: '16px!important',
    }
};
/**
 * App component
 * @returns {<ThemeProvider/>}
 */
function App() {
    // Configure Crisp
    useEffect(() => {
        Crisp.configure(process.env.CRISP_WEBSITE_ID || '');
    }, []);
    return (_jsx(ThemeProvider, Object.assign({ theme: theme }, { children: _jsxs(UserProvider, { children: [_jsx(GlobalStyles, { styles: globalStyles }), _jsxs(BrowserRouter, { children: [_jsx(ScrollToTop, {}), _jsx(Routes, { children: _jsxs(Route, Object.assign({ path: ROUTES.ROOT, element: _jsx(Root, {}) }, { children: [_jsx(Route, { index: true, element: _jsx(Navigate, { to: CLIENT_ENDPOINTS.CHAT }) }), _jsx(Route, { path: ROUTES.CHAT, element: _jsx(Document, {}) }), _jsx(Route, { path: ROUTES.TEMPLATES, element: _jsx(Document, {}) }), _jsx(Route, { path: ROUTES.TEMPLATE, element: _jsx(Document, {}) }), _jsx(Route, { path: ROUTES.DOCUMENT, element: _jsx(Document, {}) }), _jsx(Route, { path: ROUTES.PROJECT, element: _jsx(RequiredAuth, { children: _jsx(Documents, {}) }) }), _jsx(Route, { path: ROUTES.SETTING, element: _jsx(Settings, {}) }), _jsx(Route, { path: ROUTES.SIGN_IN, element: _jsx(SignIn, {}) }), _jsx(Route, { path: `${ROUTES.SIGN_IN}${ROUTES.VERIFY_MAGIC_LINK}`, element: _jsx(EmailLinkVerification, {}) }), _jsx(Route, { path: ROUTES.BRAND_VOICE, element: _jsx(RequiredAuth, { children: _jsx(BrandVoices, {}) }) }), _jsx(Route, { path: ROUTES.INFOBASE, element: _jsx(RequiredAuth, { children: _jsx(Infobase, {}) }) })] })) })] })] }) })));
}
;
export default App;
